(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tabs"] && !window.DesignMode) return;
  try {
    
class TabsAccordionManager {
  constructor(container) {
    this.container = container;
    this.tabs = container.querySelectorAll('[data-tab]');
    this.contents = container.querySelectorAll('.tab-content');
    this.accordionHeaders = container.querySelectorAll('.accordion-header');
    this.faqQuestions = container.querySelectorAll('.faq-question');
    
    this.isAnimating = false;
    
    this.init();
    this.handleResize();
  }

  init() {
    this.tabs.forEach(tab => {
      tab.addEventListener('click', () => this.switchTab(tab));
    });
    this.accordionHeaders.forEach(header => {
      header.addEventListener('click', () => this.toggleAccordion(header));
    });
    this.faqQuestions.forEach(question => {
      question.addEventListener('click', () => this.toggleFAQ(question));
    });
    window.addEventListener('resize', () => this.handleResize());

    // Initialize all accordion contents with proper initial state
    this.container.querySelectorAll('[id^="accordion-"]').forEach(content => {
      if (!content.closest('.accordion-header')?.classList.contains('active')) {
        content.style.maxHeight = '0px';
        content.style.overflow = 'hidden';
        content.style.display = 'none';
      }
    });
  }

  handleResize() {
    const isMobile = window.innerWidth <= 991;
    if (isMobile) {
      this.contents.forEach(content => {
        content.style.display = 'none';
        content.style.maxHeight = '0px';
      });
    } else {
      // Reset accordion states
      this.accordionHeaders.forEach(header => {
        header.classList.remove('active');
        const content = this.container.querySelector(`#accordion-${header.dataset.accordion}`);
        if (content) {
          content.style.display = 'none';
          content.style.maxHeight = '0px';
        }
      });
      // Show active tab content
      const activeTab = this.container.querySelector('.tab-button.active');
      if (activeTab) {
        const targetId = activeTab.dataset.tab;
        const activeContent = this.container.querySelector(`#${targetId}`);
        activeContent.style.display = 'block';
        activeContent.style.maxHeight = 'none';
      }
    }
  }

  switchTab(selectedTab) {
    const targetId = selectedTab.dataset.tab;
    this.tabs.forEach(tab => {
      tab.classList.remove('active');
      tab.setAttribute('aria-selected', 'false');
    });
    selectedTab.classList.add('active');
    selectedTab.setAttribute('aria-selected', 'true');
    
    this.contents.forEach(content => {
      content.classList.remove('active');
      content.style.display = 'none';
      content.style.maxHeight = '0px';
    });
    
    const activeContent = this.container.querySelector(`#${targetId}`);
    activeContent.classList.add('active');
    activeContent.style.display = 'block';
    activeContent.style.maxHeight = 'none';
  }

  async toggleAccordion(header) {
    if (this.isAnimating) return;
    this.isAnimating = true;

    const content = this.container.querySelector(`#accordion-${header.dataset.accordion}`);
    if (!content) {
      this.isAnimating = false;
      return;
    }

    const isOpen = header.classList.contains('active');
    
    // Close other accordions
    for (const h of this.accordionHeaders) {
      if (h !== header && h.classList.contains('active')) {
        const otherContent = this.container.querySelector(`#accordion-${h.dataset.accordion}`);
        if (otherContent) {
          await this.animateAccordion(h, otherContent, false);
        }
      }
    }

    // Toggle clicked accordion
    await this.animateAccordion(header, content, !isOpen);
    this.isAnimating = false;
  }

  async animateAccordion(header, content, open) {
    return new Promise(resolve => {
      if (open) {
        // Opening animation
        content.style.display = 'block';
        content.style.overflow = 'hidden';
        
        // Reset max-height to 0 first
        content.style.maxHeight = '0px';
        
        // Force reflow
        content.offsetHeight;
        
        // Set up transition
        content.style.transition = 'max-height 0.3s ease-out';
        
        // Set max-height to a value larger than content height
        // Using scrollHeight + some padding to ensure full expansion
        content.style.maxHeight = `${content.scrollHeight + 100}px`;
        
        header.classList.add('active');
        
        const onTransitionEnd = () => {
          // After animation, set to 'none' to allow dynamic content changes
          content.style.maxHeight = 'none';
          content.style.overflow = 'visible';
          content.removeEventListener('transitionend', onTransitionEnd);
          resolve();
        };
        
        content.addEventListener('transitionend', onTransitionEnd);
      } else {
        // Closing animation
        content.style.overflow = 'hidden';
        
        // Set exact height before animation
        content.style.maxHeight = `${content.scrollHeight}px`;
        
        // Force reflow
        content.offsetHeight;
        
        // Set up transition
        content.style.transition = 'max-height 0.3s ease-out';
        content.style.maxHeight = '0px';
        
        header.classList.remove('active');
        
        const onTransitionEnd = () => {
          content.style.display = 'none';
          content.removeEventListener('transitionend', onTransitionEnd);
          resolve();
        };
        
        content.addEventListener('transitionend', onTransitionEnd);
      }
    });
  }

  toggleFAQ(question) {
    const answer = question.querySelector('.faq-answer');
    const isOpen = question.classList.contains('active');
    
    this.faqQuestions.forEach(q => {
      if (q !== question) {
        q.classList.remove('active');
        const otherAnswer = q.querySelector('.faq-answer');
        otherAnswer.style.display = 'none';
        otherAnswer.style.maxHeight = '0px';
      }
    });
    
    question.classList.toggle('active');
    if (isOpen) {
      answer.style.display = 'none';
      answer.style.maxHeight = '0px';
    } else {
      answer.style.display = 'block';
      answer.style.maxHeight = 'none';
    }
  }
}

document.addEventListener('DOMContentLoaded', () => {
  const tabsContainers = document.querySelectorAll('[data-tabs]');
  tabsContainers.forEach(container => new TabsAccordionManager(container));
});

  } catch(e) { console.error(e); }
})();
})();
